module.exports = __webpack_public_path__ + "img/3_100.8b5f19b8.png";